import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';

import { Table, TableHeaderCell } from 'core';
import { Label } from 'core/components/label';
import NoResults from '../no-results';
import OfferItem from './offer-item';
import useStyles from './offer-results.styles';

const OffersResults = ({ loading, hits, totalHits, page, onPageChange, showHeader, error }) => {
  const classes = useStyles();

  return (
    <>
      {showHeader && (
        <Label type="subtitle" style={{ marginBottom: 16 }}>
          Offers
        </Label>
      )}

      <Paper>
        {Boolean(loading || hits.length) && (
          <Table
            selfContained={false}
            loading={loading}
            paginationEnabled
            count={totalHits}
            rowsPerPage={hits.length}
            currentPage={page}
            onPageChange={(_, page) => onPageChange(page)}
            header={
              <>
                <TableHeaderCell tableClasses={classes.headerCell} columnId="fname">
                  First Name
                </TableHeaderCell>
                <TableHeaderCell tableClasses={classes.headerCell} columnId="lname">
                  Last Name
                </TableHeaderCell>
                <TableHeaderCell tableClasses={classes.headerCell} columnId="address">
                  Primary property location
                </TableHeaderCell>
                <TableHeaderCell tableClasses={classes.headerCell} columnId="offers">
                  Eligible Offers
                </TableHeaderCell>
                <TableHeaderCell tableClasses={classes.headerCell} columnId="representative">
                  Offer Rep
                </TableHeaderCell>
                <TableHeaderCell tableClasses={classes.headerCell} columnId="updatedDateTime">
                  Last Update
                </TableHeaderCell>
              </>
            }
            body={Boolean(hits && hits.length) && hits.map((hit) => <OfferItem key={hit.id} offer={hit} />)}
          />
        )}
        {!loading && hits.length === 0 && <NoResults error={error} />}
      </Paper>
    </>
  );
};

OffersResults.propTypes = {
  loading: PropTypes.bool.isRequired,
  hits: PropTypes.array,
  totalHits: PropTypes.number,
  page: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  showHeader: PropTypes.bool.isRequired,
  error: PropTypes.object
};

OffersResults.defaultProps = {
  hits: [],
  totalHits: 0
};

export default memo(OffersResults);
